import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateFilterShare as UpdateFilterShareMutation,
    UpdateFilterShareVariables as UpdateFilterShareVariables,
    FilterShareUpdateInput,
} from 'nutshell-graphql-types';

import UPDATE_FILTER_SHARE from '../mutations/update-filter-share.graphql';

export const useUpdateFilterShare = (): {
    updateFilterShare: (arg1: FilterShareUpdateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateFilterShare, {loading, error}] = useMutation<
        UpdateFilterShareMutation,
        UpdateFilterShareVariables
    >(UPDATE_FILTER_SHARE);

    return {
        updateFilterShare: (input: FilterShareUpdateInput) =>
            updateFilterShare({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
